// extracted by mini-css-extract-plugin
module.exports = {"container":"container--3oqKl","order":"order--vm4HA","line":"line--1sxMf","label":"label--bVJJH","value":"value--2D67j","date":"date--VKxuk"};